// @flow
import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind-styled-components'

type Props = {
  rows?: number,
  disabled?: boolean,
  placeholder?: string,
}

const StyledTextArea = styled.textarea`
  &::placeholder {
    font-size: 16px;
  }
`

const TwTextArea = tw(StyledTextArea)`
  border
  border-gray-300
  rounded-md
  shadow-sm
  focus:border-blue-300
  focus:ring
  focus:ring-blue-200/50
  block
  w-full
  transition
  duration-150
  ease-in-out
  sm:text-sm
  sm:leading-5
  resize-none
  p-2
  placeholder:italic
  placeholder:text-slate-400

  &::placeholder {
    color: red;
  }
`

function TextArea({
  rows = 10,
  disabled = false,
  placeholder,
}: Props): React$Node {
  return (
    <TwTextArea disabled={disabled} placeholder={placeholder} rows={rows} />
  )
}

export default TextArea
